export default {"src":"/_next/static/media/paper.14197165.svg","height":51,"width":51};